import { render, staticRenderFns } from "./SelectBoxForAdmin.vue?vue&type=template&id=0ebcc693"
import script from "./SelectBoxForAdmin.vue?vue&type=script&lang=js"
export * from "./SelectBoxForAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports